//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  cloneDeep,
  isEqual,
} from '@/utils/lodash'
import CDropdownMenu from '../CDropdownMenu'
import CSmartDropdownItem from './CSmartDropdownItem'

export default {
  name: 'CSmartDropdown',

  components: {
    CDropdownMenu,
    CSmartDropdownItem,
  },

  inheritAttrs: false,

  props: {
    value: {
      type: Object,
      default: () => {},
    },

    config: {
      type: Array,
      default: () => [],
    },
  },

  data () {
    return { iModel: {} }
  },

  watch: {
    value: {
      immediate: true,
      deep: true,
      handler () {
        if (!isEqual(this.value, this.iModel)) {
          this.iModel = cloneDeep(this.value)
        }
      },
    },

    iModel: {
      immediate: true,
      deep: true,
      handler () {
        this.$emit('input', this.iModel)
      },
    },
  },

  methods: {
    handleInput (key, value) {
      this.iModel[key] = value
    },

    handleClose (key) {
      this.$emit('close', key)
    },

    handleOpen (key) {
      this.$emit('open', key)
    },

    handleChange (key, value) {
      this.$emit('change', key, value)
      this.$emit('input', this.iModel)
    },
  },
}
